<template>
    <b-col cols="12">
        <b-row>
            <slot name="metodosPago"></slot>
            <b-col cols="12">
                <h4>Antes de continuar comprueba que todos los datos estén bien:</h4>
            </b-col>
            <b-col cols="12">
                <ul>
                    <li v-if="direccionFiscal.n_cliente">
                        <b>Nº de cliente: </b>{{ direccionFiscal.n_cliente }}
                    </li>
                    <li>
                        <b>Nombre: </b>{{ direccionFiscal.nombre }}
                    </li>
                    <li>
                        <b>Nif: </b>{{ direccionFiscal.nif }}
                    </li>
                    <li>
                        <b>Dirección: </b>{{ direccionFiscal.direccion }}
                    </li>
                    <li>
                        <b>Código postal: </b>{{ direccionFiscal.cp }}
                    </li>
                    <li>
                        <b>Ciudad: </b>{{ direccionFiscal.ciudad }}
                    </li>
                    <li>
                        <b>Nº de cuenta: </b>{{ direccionFiscal.n_cuenta }}
                    </li>
                </ul>
            </b-col>
            <b-col cols="12">
                <p>
                    <b>Si estos datos no son correctos haz click en el siguiente botón para editarlos:</b>
                    <EditarDireccionFiscalModal
                        :direccionFiscal="direccionFiscal"
                        :disabled="disabled"
                        @editado="editarDireccionFiscal"
                    />
                </p>
            </b-col>
            <b-col cols="12" class="text-center">
                <b-button block type="submit" :disabled="disabled">
                    <i class="fa fa-arrow-down mr-3"></i>Continuar<i class="fa fa-arrow-down ml-3"></i>
                </b-button>
                <slot></slot>
            </b-col>
        </b-row>
    </b-col>
</template>

<script>
    import EditarDireccionFiscalModal from '@/components/backend/direcciones-fiscales/modals/EditarDireccionFiscalModal';

    export default {
        props: {
            direccionFiscal: {
                type: Object
            },
            disabled: {
                type: Boolean,
                required: true
            }
        },
        methods: {
            editarDireccionFiscal(newDireccionFiscal) {
                this.$emit('update:direccionFiscal', newDireccionFiscal);
            }
        },
        components: {
            EditarDireccionFiscalModal
        }    
    }
</script>